"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranscriptionController = void 0;
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const rxjs_1 = require("rxjs");
const utils_1 = require("../wall/utils");
const fetch_download_url_1 = require("../../util/fetch_download_url");
const toolbox_1 = require("@streem/toolbox");
class TranscriptionController {
    constructor(config) {
        this.config = config;
        this.transcriptions = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('artifact'), (0, utils_1.accumulateAndTransformWallEvents)('artifact', (artifact) => __awaiter(this, void 0, void 0, function* () {
            if (artifact.artifactType !== streem_sdk_protobuf_1.WallItem.ArtifactType.TRANSCRIPTION)
                return artifact;
            if (!artifact.transcription)
                return artifact;
            (0, toolbox_1.invariant)(artifact.transcription.storageUrl, 'Recording must have storage URL');
            const ready = artifact.status === streem_sdk_protobuf_1.WallItem.Artifact.Status.FULFILLED;
            if (ready && artifact.transcription.storageUrl) {
                const downloadUrl = yield (0, fetch_download_url_1.fetchDownloadUrl)(this.config.context.roomId, artifact.transcription.storageUrl);
                artifact.transcription.url = downloadUrl;
            }
            return artifact;
        })), (0, utils_1.filterByProperty)('artifactType', streem_sdk_protobuf_1.WallItem.ArtifactType.TRANSCRIPTION), (0, rxjs_1.map)(transcriptions => transcriptions.filter(item => item.transcription.url)), (0, rxjs_1.shareReplay)(1));
    }
}
exports.TranscriptionController = TranscriptionController;
//# sourceMappingURL=transcription_controller.js.map